import lazyRetry from './lazyLoader';
import MainLayout from 'layout/MainLayout.tsx';
import Lazy from 'components/Lazy.tsx';
import { lazy } from 'react';

const BatchJobExecutionsView = Lazy(lazy(() => lazyRetry(() => import('views/batch-jobs/BatchJobExecutionsView.tsx'))));
const BatchJobIterationsView = Lazy(lazy(() => lazyRetry(() => import('views/batch-jobs/BatchJobIterationsView.tsx'))));

const ProjectBatchJobExecutionsRoutes = {
  path: '/projects/:projectId/batch-job-executions/',
  element: <MainLayout />,
  children: [
    {
      path: '',
      element: <BatchJobExecutionsView />,
    },
    {
      path: ':batchJobExecutionId',
      element: <BatchJobIterationsView />,
    },
  ],
};

export default ProjectBatchJobExecutionsRoutes;
